import { api } from './userService';

const PLATFORM_WEB = 3;

export const pushNotificationService = {
  async getPushConfig() {
    console.info('[push] getPushConfig: GET /api/notifications/push-config');
    try {
      const response = await api.get('/api/notifications/push-config');
      const data = response?.data;

      if (!data) {
        console.warn('[push] getPushConfig: response.data vazio');
        return null;
      }

      const config = data?.config ?? data ?? null;
      const vapid = data?.vapidKey ?? data?.vapidPublicKey ?? data?.webPushVapidKey ?? data?.webPushPublicKey ?? null;

      if (!config) {
        console.warn('[push] getPushConfig: config não encontrada no response');
        return null;
      }

      console.info('[push] getPushConfig: OK', { hasVapid: Boolean(vapid) });
      return {
        ...config,
        ...(vapid ? { vapidKey: vapid } : {})
      };
    } catch (err) {
      console.error('[push] getPushConfig: erro', err?.response?.status, err?.message, err);
      throw err;
    }
  },

  async registerDevice({ token, language, metadata }) {
    const payload = {
      token,
      platform: PLATFORM_WEB,
      language,
      metadata
    };

    const response = await api.post('/api/notifications/devices', payload);
    return response?.data;
  },

  async sendTestPush({ templateKey, parameters }) {
    const response = await api.post('/api/notifications/push', {
      templateKey,
      parameters
    });

    return response?.data;
  }
};
